import * as THREE from 'three'
import * as dat from 'lil-gui'
import gsap from 'gsap'


// Debug
//const gui = new dat.GUI()

const parameters = {
    materialColor: '#947b71',
    lightColor: '#eedbff',
    ambientColor: '#ff9d52',
}

// gui
//     .addColor(parameters, 'materialColor')
//     .onChange(() =>
//     {
//         particlesMaterial.color.set(parameters.materialColor)
//     })
// gui.addColor(parameters, 'ambientColor')
// .onChange(() =>
//     {
//         ambientLight.color.set(parameters.ambientColor)
//     })
// gui.addColor(parameters, 'lightColor')
// .onChange(() =>
//     {
//         directionalLight.color.set(parameters.lightColor)
//     })


/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Objects
 */
// Texture
const textureLoader = new THREE.TextureLoader()

const coalTexture = textureLoader.load('textures/118.png')
coalTexture.magFilter=THREE.NearestFilter
const copperTexture = textureLoader.load('textures/120.png')
copperTexture.magFilter=THREE.NearestFilter
const ironTexture = textureLoader.load('textures/170.png')
ironTexture.magFilter=THREE.NearestFilter
const goldTexture = textureLoader.load('textures/157.png')
goldTexture.magFilter=THREE.NearestFilter
const lapisTexture = textureLoader.load('textures/174.png')
lapisTexture.magFilter=THREE.NearestFilter
const redTexture = textureLoader.load('textures/049.png')
redTexture.magFilter=THREE.NearestFilter
const emeraldTexture = textureLoader.load('textures/150.png')
emeraldTexture.magFilter=THREE.NearestFilter
const diamondTexture = textureLoader.load('textures/146.png')
diamondTexture.magFilter=THREE.NearestFilter




// Material
const coalMat = new THREE.MeshLambertMaterial({map:coalTexture})
const copperMat = new THREE.MeshLambertMaterial({map:copperTexture})
const ironMat = new THREE.MeshLambertMaterial({map:ironTexture})
const goldMat = new THREE.MeshLambertMaterial({map:goldTexture})
const lapisMat = new THREE.MeshLambertMaterial({map:lapisTexture})
const redMat = new THREE.MeshLambertMaterial({map:redTexture})
const emeraldMat = new THREE.MeshLambertMaterial({map:emeraldTexture})
const diamondMat = new THREE.MeshLambertMaterial({map:diamondTexture})

// Objects
const objectsDistance = 4
const cube = new THREE.BoxGeometry(1.5,1.5,1.5)
const mesh1 = new THREE.Mesh( cube, coalMat)
const mesh2 = new THREE.Mesh( cube, copperMat)
const mesh3 = new THREE.Mesh( cube, ironMat)
const mesh4 = new THREE.Mesh( cube, goldMat)
const mesh5 = new THREE.Mesh( cube, lapisMat)
const mesh6 = new THREE.Mesh( cube, redMat)
const mesh7 = new THREE.Mesh( cube, emeraldMat)
const mesh8 = new THREE.Mesh( cube, diamondMat)
scene.add(mesh1, mesh2, mesh3, mesh4, mesh5, mesh6, mesh7, mesh8)

//blocks positions
const sectionMeshes = [mesh1, mesh2, mesh3, mesh4, mesh5, mesh6, mesh7, mesh8]
const StartRatio =window.innerHeight > window.innerWidth? true:false
for (const x in sectionMeshes){
    sectionMeshes[x].position.y =StartRatio? - objectsDistance * x +1:- objectsDistance * x
    sectionMeshes[x].position.x =StartRatio? 0:-2
    sectionMeshes[x].rotation.x = Math.random()*20
    StartRatio?  sectionMeshes[x].scale.set(0.75,0.75,0.75) : sectionMeshes[x].scale.set(1,1,1)
}

/**
 * Lights
 */
const directionalLight = new THREE.DirectionalLight(parameters.lightColor, 1)
directionalLight.position.set(1, -0.2, 2)
const ambientLight = new THREE.DirectionalLight(parameters.ambientColor)
ambientLight.position.set(-2, 1.5, 0)
const ambientLight2 = new THREE.DirectionalLight(parameters.ambientColor)
ambientLight2.position.set(-2, -1.5, 0)

scene.add(directionalLight)
scene.add(ambientLight)

// const helper = new THREE.DirectionalLightHelper(directionalLight);
// scene.add( helper );
// const helper2 = new THREE.DirectionalLightHelper(ambientLight);
// scene.add( helper2 );
// const helper3 = new THREE.DirectionalLightHelper(ambientLight2);
// scene.add( helper3 );
/**
 * Particles
 */
// Geometry
const particlesCount = 200
const positions = new Float32Array(particlesCount * 3)
const rotations = new Float32Array(particlesCount * 3)


for(let i = 0; i < particlesCount; i++)
{
    positions[i * 3 + 0] = (Math.random()-1) * 5
    positions[i * 3 + 1] = objectsDistance * 0.5 - Math.random() * objectsDistance * sectionMeshes.length
    positions[i * 3 + 2] = (Math.random() - 0.5) * 10
}

const particlesGeometry = new THREE.BufferGeometry()
particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))
particlesGeometry.setAttribute('rotation', new THREE.BufferAttribute(positions, 3))

// Material
// const particleTex = textureLoader.load('particle.png')
// particleTex.magFilter = THREE.NearestFilter
const particlesMaterial = new THREE.PointsMaterial({
    color: parameters.materialColor,
    sizeAttenuation: textureLoader,
    size: 0.04,
    // map:particleTex,
    // transparent:true,
    // depthWrite:false,
})

// Points
const particles = new THREE.Points(particlesGeometry, particlesMaterial)
scene.add(particles)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}


window.addEventListener('resize', (event) =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    //Update mobile
    if (sizes.height > sizes.width ) {
        // camera.position.z += 0
        // camera.position.y += 0
        camera.position.x = 0
        for (const x in sectionMeshes){
            sectionMeshes[x].position.x = 0
            sectionMeshes[x].position.y = - objectsDistance * x +1
            sectionMeshes[x].scale.set(0.74,0.74,0.74)
        } }else {
            camera.position.x = -(sizes.height*3/sizes.width)+1.5
            for (const x in sectionMeshes){
            sectionMeshes[x].position.y = - objectsDistance * x
            sectionMeshes[x].position.x = -2
            sectionMeshes[x].scale.set(1,1,1)
    }}
    
    scrollTo(0,scrollY/CurrentHeight*window.innerHeight)
})

/**
 * Camera
 */
// Group
const cameraGroup = new THREE.Group()
scene.add(cameraGroup)

// Base camera
const camera = new THREE.PerspectiveCamera(35, sizes.width / sizes.height, 0.1, 100)
camera.position.z = 6
camera.position.x = StartRatio? 0:-(sizes.height*3/sizes.width)+1.5
cameraGroup.add(camera)


/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Scroll
 */
let CurrentHeight = 0
let scrollY = window.scrollY
let currentSection = 0

window.addEventListener('scroll', () =>
{
    CurrentHeight = window.innerHeight
    scrollY = window.scrollY
    const newSection = Math.round(scrollY / sizes.height)

    if(newSection != currentSection)
    {currentSection = newSection}

})

//click animation
let intersectBool = false
window.addEventListener('click', () =>{
    if (intersectBool){
        console.log("click")
        gsap.to(
            sectionMeshes[currentSection].rotation,
            {
                duration: 1,
                ease: 'power2.out',
                // x: '+=6',
                y: '+=4',
                // z: '+=1.5'
            }
        )
    }
    
})



/**
 * Cursor
 */
const cursor = {}
cursor.x = 0
cursor.y = 0
const mousehover = new THREE.Vector2

window.addEventListener('mousemove', (event) =>
{
    cursor.x = event.clientX / sizes.width - 0.5
    cursor.y = event.clientY / sizes.height - 0.5

    // mousehover.x = ( ( event.clientX - rect.left ) / ( rect.width - rect.left ) ) * 2 - 1;
    // mousehover.y = - ( ( event.clientY - rect.top ) / ( rect.bottom - rect.top) ) * 2 + 1;
    mousehover.x = cursor.x * 2
    mousehover.y = - cursor.y * 2
})

/**
 * Animate
 */
const clock = new THREE.Clock()
let previousTime = 0

const rayCaster = new THREE.Raycaster
let currentIntersect = null
const tick = () =>
{

    
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - previousTime
    previousTime = elapsedTime

    // Animate camera
    camera.position.y = - scrollY / sizes.height * objectsDistance

    const parallaxX = cursor.x * 0.5
    const parallaxY = - cursor.y * 0.5
    if (window.innerWidth > 767)
    {
     cameraGroup.position.x += (parallaxX - cameraGroup.position.x) * 10 * deltaTime
     cameraGroup.position.y += (parallaxY - cameraGroup.position.y) * 10 * deltaTime
    }
    // Animate meshes
    for(const mesh of sectionMeshes)
    {
        mesh.rotation.x += deltaTime * -0.06
        mesh.rotation.y += deltaTime * 0.08
    }

    
    // Hovered item detector
    rayCaster.setFromCamera(mousehover,camera)
    const intersects = rayCaster.intersectObjects(sectionMeshes)

    intersectBool = intersects.length

    // if(intersects.length)
    // {
    //     console.log('intersected')
    // }
    // else


    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()